import * as React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { styled } from "@mui/material";

const CostomizedButtons = styled(Button)`
  margin: 10px 10px;
  width: 125px;
`;

export default function BasicButtons({
  children,
  onClick,
  type,
  margin,
  component,
  startIcon,
  width,
}) {
  return (
    <Stack spacing={2} direction="row">
      <CostButton
        type={type}
        variant="contained"
        onClick={onClick}
        mrg={margin}
        component={component}
        startIcon={startIcon}
        width={width}
      >
        {children}
      </CostButton>
    </Stack>
  );
}

const CostButton = styled(CostomizedButtons)`
  margin: ${(props) => props.mrg};
  width: ${(props) => props.width};
`;
